import React, { useEffect } from "react";
// react-redux
import { useDispatch, useSelector } from "react-redux";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
// react-fitted-image
import FittedImage from "react-fitted-image";
// actions
import { fetchArticle } from "../../store/actions/WordPressApiAction";
// styles
import styles from "./articleViewStyle";
// components
import PrevNextArticle from "../../components/PrevNextArticle/PrevNextArticle";

// util
import { conversionDate } from "../../util/util";
const useStyles = makeStyles(styles);
/**
 * 記事詳細の表示画面
 * @param {*} props
 */
export default function ArticleView(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const postsData = useSelector((state) => state.fetchArticleReducer);

  /**
   * 記事情報取得
   */
  useEffect(() => {
    dispatch(fetchArticle(props.slug));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.slug]);

  /**
   * 表示する記事のレイアウトを定義
   */
  function displayArticle() {
    if (postsData.posts.length > 0) {
      return (
        <div className={classes.articleContainer}>
          <div className={classes.title}>
            {postsData.posts[0].title.rendered}
          </div>
          <div className={classes.postDate}>
            {conversionDate(postsData.posts[0].date)}
          </div>
          <FittedImage
            fit="cover"
            loader={<div>Loading</div>}
            onLoad={(...args) => console.log(...args)}
            onError={(...args) => console.log(...args)}
            src={postsData.posts[0]._embedded["wp:featuredmedia"][0].source_url}
            className={classes.eyeCatchImg}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: postsData.posts[0].content.rendered,
            }}
          ></div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
  /**
   * 現在の記事の前後の記事情報表示関数
   */
  function prevNextArticle() {
    if (postsData.posts.length > 0) {
      var prevTitle = "BlogTopへ";
      var prevArticleURL = "/";
      var prevImgURL = props.basicInfo.site_img;
      var nextTitle = "BlogTopへ";
      var nextArticleURL = "/";
      var nextImgURL = props.basicInfo.site_img;
      //前の記事情報
      if (!(postsData.posts[0].prev === "")) {
        prevTitle = postsData.posts[0].prev.post_title;
        prevArticleURL = postsData.posts[0].prev.permalink;
        prevImgURL = postsData.posts[0].prev.featured_image_src;
      }
      // //次の記事情報
      if (!(postsData.posts[0].next === "")) {
        nextTitle = postsData.posts[0].next.post_title;
        nextArticleURL = postsData.posts[0].next.permalink;
        nextImgURL = postsData.posts[0].next.featured_image_src;
      }
      return (
        <PrevNextArticle
          siteURL={props.basicInfo.site_url}
          prevTitle={prevTitle}
          prevArticleURL={prevArticleURL}
          prevImgURL={prevImgURL}
          nextTitle={nextTitle}
          nextArticleURL={nextArticleURL}
          nextImgURL={nextImgURL}
        />
      );
    } else {
      return <div></div>;
    }
  }

  return (
    <Grid container spacing={0} className={classes.mainViewContainer}>
      <Grid item xs={12}>
        {displayArticle()}
        {prevNextArticle()}
      </Grid>
    </Grid>
  );
}
